"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dashboardTranslator = void 0;
exports.dashboardTranslator = {
    en: {
        listHeader: "GDD LIST",
        createButton: "CREATE",
    },
    ru: {
        listHeader: "СПИСОК GDD",
        createButton: "СОЗДАТЬ",
    },
};
